import { MutationTree } from 'vuex';
import { IProfileState } from './profile-state.store';
import {
  PROFILE_LOADING,
  PROFILE_SET_MEMBERS,
  PROFILE_SET_ENTITY_ROLES,
  PROFILE_SET_TOTAL_PAGES,
  PROFILE_SET_CURRENT_FILTER,
  PROFILE_INIT_MEMBERS,
  PROFILE_INIT_MEMBER,
  PROFILE_SET_MEMBER_BY_FIELD,
  PROFILE_SET_MEMBER_PARAMETER,
  PROFILE_EXTEND_MEMBERS,
  PROFILE_SET_INTERNAL_ROLES,
  PROFILE_SET_EXTERNAL_ROLES,
  PROFILE_ACTION,
  PROFILE_SET_MEMBER_SELECTION,
  PROFILE_INIT_MEMBER_SELECTION,
  PROFILE_SPLICE_MEMBERS,
  PROFILE_UPDATE_MEMBERS,
  PROFILE_SET_PAGINATION_PAGE,
  PROFILE_SET_CIVILITY_LEGAL_FORM,
  PROFILE_SET_LOADER_STATE, PROFILE_INIT_CURRENT_MEMBER, PROFILE_SET_TICKET_CLOSING_REASON, PROFILE_SET_TICKET_SUBSTATUS, PROFILE_SET_TICKET_REASON
} from './profile-types.store';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
import { ITeamMember } from '../../models/profile/member.model';
import { IMemberParameter } from '../../models/profile/member.parameter';
import { CrudStatus } from '../../common/enums';

export const mutations: MutationTree<IProfileState> = {
  [PROFILE_LOADING]: (state: IProfileState, activityStatus: ActivityStatus) => {
    state.activityStatus = activityStatus;
  },
  [PROFILE_SET_MEMBERS]: (state: IProfileState, membersData: any ) => {
    const page= membersData.skip / membersData.limit + 1
    var result= state.members.set(`${page}`,membersData.data)
  }
  ,[PROFILE_EXTEND_MEMBERS] : (state: IProfileState, member: any ) => {
     const { current_filter, role } = state.memberParameter
     if( current_filter  === 'team' || current_filter || 'external' || role.indexOf(member.role_id) !== -1  ){
        var pageMembers= state.members.get(`${state.pagination.total_pages}`)
        if(pageMembers)
          if(pageMembers.length < 10){
            pageMembers.push(member)
            state.members.set(`${state.pagination.total_pages}`,pageMembers)
          }
          else{
            state.total_pages += 1
            state.members.set(`${state.pagination.total_pages}`,[member])
          }

     }
  }
  ,[PROFILE_SPLICE_MEMBERS] : (state: IProfileState, memberId: number) => {
    var pageMembers= state.members.get(`${state.pagination.page}`)
    if(pageMembers){
      const index= pageMembers.map(member=> member.id).indexOf(memberId)
      pageMembers.splice(index,1)
      state.members.set(`${state.pagination.page}`,pageMembers)
    }
  }
  ,[PROFILE_UPDATE_MEMBERS] : (state: IProfileState, member: any) => {
    var pageMembers= state.members.get(`${state.pagination.page}`)
    if(pageMembers){
      const memberIndex= pageMembers.map(member=> member.id).indexOf(member.id)
      pageMembers.splice(memberIndex,1)
      pageMembers.unshift(member)
      state.members.set(`${state.pagination.page}`,pageMembers)
    }
  }
  ,[PROFILE_SET_TOTAL_PAGES] : ( state: IProfileState, total: number ) => {
    let pages= total / 10
    if(Math.floor(pages) !== pages ) pages = Math.floor(pages) + 1

    state.total_pages= pages
    state.pagination= {
      ...state.pagination,
      total_pages: pages,
      totalItems: total
    }
  },
  [PROFILE_SET_PAGINATION_PAGE] : (state: IProfileState, page: number ) => {
    state.pagination.page= page
  },
  [PROFILE_SET_ENTITY_ROLES]: (state: IProfileState, roles: any[] ) => {
     state.entity_roles= roles
  },
  [PROFILE_SET_INTERNAL_ROLES]: (state: IProfileState, roles: any[] ) => {
     state.internal_entity_roles= roles.map( role => ({ ...role, text: role.name }) )
  },
  [PROFILE_SET_EXTERNAL_ROLES] : (state: IProfileState, roles: any[] ) => {
    state.external_entity_roles= roles.map( role => ({ ...role, text: role.name }) )
  },
  [PROFILE_SET_CIVILITY_LEGAL_FORM] : (state: IProfileState, civilities: { id: number, text: string }[] ) => {
    state.civilities= civilities
  },
  [PROFILE_SET_CURRENT_FILTER]: (state: IProfileState, filter: number[] ) => {
    if(!filter.length) state.current_filter= 'team'
    else state.current_filter= filter.join()
  },
  [PROFILE_INIT_MEMBERS] : (state: IProfileState ) => {
     state.members = new Map()
  },
  [PROFILE_INIT_MEMBER] : (state: IProfileState, member: ITeamMember ) => {
    state.member= member
  },
  [PROFILE_INIT_CURRENT_MEMBER]: (state: IProfileState, member: ITeamMember) => {
    state.currentMember = member
  },
  [PROFILE_SET_MEMBER_BY_FIELD] : (state: IProfileState, payload: ITeamMember ) => {
     state.member= {
       ...state.member,
       ...payload
     }
  },
  [PROFILE_SET_MEMBER_PARAMETER] : (state: IProfileState, payload: IMemberParameter ) => {
    state.memberParameter= Object.assign({},state.memberParameter,payload)
  },
  [PROFILE_ACTION] : (state: IProfileState, action: CrudStatus) => {
    state.crudActionStatus= action
  },
  [PROFILE_SET_MEMBER_SELECTION] : (state: IProfileState, id: number ) =>{
    const index: number= state.memberSelection.indexOf(id)
    if( index === -1 ) state.memberSelection.push(id)
    else state.memberSelection.splice(index,1)
  },
  [PROFILE_INIT_MEMBER_SELECTION]: (state: IProfileState) => {
    state.memberSelection= []
  },
  [PROFILE_SET_LOADER_STATE] : (state: IProfileState, payload: { key: any, value: boolean }) => {
      const map: Map<string,boolean> = typeof payload.key === 'string' ?
                                new Map([ [payload.key ,payload.value] ]) :
                                      new Map(payload.key.map( (key: string) => [key,payload.value]))

      state.loaders= new Map([
        ...state.loaders,
        ...map
      ])
  },
  [PROFILE_SET_TICKET_CLOSING_REASON] : (state: IProfileState, closingReason ) => {
    state.closingReason = Object.assign({},state.closingReason,closingReason)
  },
  [PROFILE_SET_TICKET_REASON] : (state: IProfileState, ticketReason ) => {
    state.ticketReason = Object.assign({},state.ticketReason,ticketReason)
  },
  [PROFILE_SET_TICKET_SUBSTATUS] : (state: IProfileState, ticketSubstatus ) => {
    state.ticketSubstatus = Object.assign({},state.ticketSubstatus,ticketSubstatus)
  },
}



// WEBPACK FOOTER //
// ./src/store/profile/profile-mutations.store.ts